import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { MonitoringTimeSeries } from '@/types/agents';

interface RunsChartProps {
    data: MonitoringTimeSeries[];
}

const RunsChart: React.FC<RunsChartProps> = ({ data }) => {

    const formatXAxisLabel = (timestamp: string) => {
        const date = new Date(timestamp);
        return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    };

    const chartData = data.map(item => ({
        ...item,
        timestamp: formatXAxisLabel(item.timestamp),
    }));

    return (
        <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" opacity={0.3} />
                    <XAxis
                        dataKey="timestamp"
                        stroke="hsl(var(--muted-foreground))"
                        fontSize={12}
                    />
                    <YAxis
                        stroke="hsl(var(--muted-foreground))"
                        fontSize={12}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "hsl(var(--background))",
                            border: `1px solid hsl(var(--border))`,
                            borderRadius: '8px',
                        }}
                        labelStyle={{ color: "hsl(var(--foreground))" }}
                    />
                    <Legend />
                    <Line
                        type="monotone"
                        dataKey="runs"
                        stroke="hsl(var(--primary))"
                        strokeWidth={2}
                        name="Total Runs"
                        dot={{ fill: "hsl(var(--primary))", strokeWidth: 2, r: 4 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="successes"
                        stroke="hsl(var(--secondary))"
                        strokeWidth={2}
                        name="Successful"
                        dot={{ fill: "hsl(var(--secondary))", strokeWidth: 2, r: 4 }}
                    />
                    <Line
                        type="monotone"
                        dataKey="failures"
                        stroke="hsl(var(--destructive))"
                        strokeWidth={2}
                        name="Failures"
                        dot={{ fill: "hsl(var(--destructive))", strokeWidth: 2, r: 4 }}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default RunsChart;

